import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Success.css";

export default function Success() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const orderNumber = state?.orderNumber || "N/A";
  const customerName = state?.customerName || "Customer";
  const total = state?.total;

  return (
    <div className="success-container">
      <div className="success-card">
        <h1>Order Confirmed</h1>
        <p>Thank you, {customerName}.</p>
        <p>Your order has been received and will be processed soon.</p>
        <p>
          <strong>Order Number:</strong> {orderNumber}
        </p>
        {total && (
          <p>
            <strong>Total:</strong> Rs {total}
          </p>
        )}
        <button className="home-btn" onClick={() => navigate("/")}>
          Go Back to Home
        </button>
      </div>
    </div>
  );
}
